import { List } from 'immutable'
import { Store } from 'redux'

import { EXPLAIN_THE_WIZARD_FEATURE_FLAG } from 'routes/Signup/Steps/ExplainTheWizard'
import { AVAILABLE_STEP_COMPONENTS } from 'routes/Signup/constants/AvailableStepComponents'
import { SignupSteps } from 'routes/Signup/constants/SignupSteps'
import { signupConfig } from 'routes/Signup/signupConfig'

import { isOptimizelyFeatureEnabledFactory } from '../../../containers/OptimizelyRollouts'

const getIsPersonaliseSignUpEnabled = isOptimizelyFeatureEnabledFactory(
  'turnips_personalised_signup_enabled',
)

const getIsExplainTheWizardEnabled = isOptimizelyFeatureEnabledFactory(
  EXPLAIN_THE_WIZARD_FEATURE_FLAG,
)

/**
 * Returns steps for signup. Steps without a component are filtered out.
 * @param store - application redux store
 */
export const getSignupSteps = async (store: Store<any>): Promise<List<SignupSteps>> => {
  let resultSteps: List<SignupSteps>
  const isPersonaliseSignUpEnabled = await getIsPersonaliseSignUpEnabled(
    store.dispatch,
    store.getState,
  )
  const isExplainTheWizardEnabled = await getIsExplainTheWizardEnabled(
    store.dispatch,
    store.getState,
  )

  if (isPersonaliseSignUpEnabled) {
    resultSteps = List(signupConfig.personaliseMenuSteps)
  } else if (isExplainTheWizardEnabled) {
    resultSteps = List(signupConfig.explainTheWizardSteps)
  } else {
    resultSteps = List(signupConfig.defaultSteps)
  }

  /**
   * Filter out steps that do not have a component.
   */
  return resultSteps.filter(
    (step) => !!AVAILABLE_STEP_COMPONENTS[step as SignupSteps],
  ) as List<SignupSteps>
}
